import { safeText } from "./principle6SheetHelpers.js";

export function filterPopulatedRows(rows, fields) {
  const list = Array.isArray(rows) ? rows : [];
  return list.filter((item) =>
    fields.some((field) => String(item?.[field] ?? "").trim() !== "")
  );
}

export function formatExcelDate(value) {
  if (!value) return "";
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return safeText(value, "");
  const day = String(dt.getDate()).padStart(2, "0");
  const month = String(dt.getMonth() + 1).padStart(2, "0");
  const year = dt.getFullYear();
  return `${day}-${month}-${year}`;
}

export function readLocationFY(row) {
  return {
    current:
      row?.currentFinacialYear ??
      row?.currentFinancialYear ??
      row?.current_financial_year ??
      "",
    previous:
      row?.previousFinancialYear ??
      row?.previousFinacialYear ??
      row?.previous_financial_year ??
      "",
  };
}

export function setStandardDetailWidths(ws, columns) {
  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  Object.entries(columns).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });
}
